import { Component, Prop, Vue, Emit, Watch, PropSync } from 'vue-property-decorator';


@Component({
    template: '#sheet-field-template'
})
export default class SheetFieldComponent extends Vue {

    @Prop()
    private isLabel: boolean;

    @Prop()
    private isInput: boolean;

    @Prop()
    private isDisabled: boolean;

    @Prop()
    private UXIndex: string;

    @Prop()
    private customKey: string;

    @Prop()
    private value: number;

    @Prop()
    private roundNumbers: boolean;


    public get fixedValue(): string {
        if(this.roundNumbers){
            return Math.round(this.value) 
            .toLocaleString(navigator.language, {
                minimumFractionDigits: 0,
            });
        }

        return Number(this.value.toFixed(2))
            .toLocaleString(navigator.language, {
                minimumFractionDigits: 2,
            });
    }


    get syncedValue() {
        //this.fixedSyncValue = '';// this.getFixedSyncValue();
        return this.value;
    }

    set syncedValue(value: number) {
        this.$emit('update:value', this.customKey, value);
    }

}

Vue.component('sheet-field', SheetFieldComponent);